export const HIGHLIGHT_CLASS_NAME = 'hll';
export const MARKUP_FILE_TYPE = 'markup';
export const MARKUP_CONTENT_SELECTOR = '.js-markup-content';
export const ELEMENTS_PER_CHUNK = 20;
export const CONTENT_LOADED_EVENT = 'richContentLoaded';
export const MAX_BLAME_LINES = 100;
